// 将格式为{ timezone: string, gmt_offset: string, i18n_key: string }的时区翻译为用户友好的格式
export const translateTzOption = (tzOption, vm) => {
  if (!tzOption) {
    return ''
  }

  // 当有返回时区翻译文案时，直接使用
  if (tzOption.city_translation) {
    return tzOption.city_translation; // eg: "(UTC+13:00) Apia Time"
  }

  // gmt_offset格式示范: "GMT-08:00"、 "GMT+08:00"、 "GMT+00:00"
  // GMT+08:00 => UTC+08:00
  // NOTE: Etc/GMT+08:00 => UTC-08:00
  const utcOffset = tzOption.gmt_offset
    .replace('GMT', 'UTC') // will not change origin string

  return `(${utcOffset}) ${vm.$t(tzOption.i18n_key)}`
}
